import React from "react";

const ArrowDownSFillIcon = () => (
	<g>
		<path d='M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z'></path>
	</g>
);

export default ArrowDownSFillIcon;
